export default __webpack_public_path__ + "static/media/Thumbs.bdbebd1b.db";